/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import { CFButton, CFButtonChop, CustomFooterStyle } from './FooterSyledComponents';
import { CustomFooterProps } from '../../interfaces/Signature';


const CustomFooter: React.FC<CustomFooterProps> = ({
  emitRecancel,
  texts,
  firmaStyle,
  typeSignature,
}) => {
  return (
    <CustomFooterStyle>
      {firmaStyle === 'ECO' && (
        <>
          {/*      <div>{<CustomSeparator />}</div> */}
          <CFButton>
            <p
              onClick={() => emitRecancel(true)}
              style={{
                fontSize: '13px',
                color: '#7cb6c0',
                backgroundColor: 'transparent',
                cursor: 'pointer',
              }}
            >
              {texts?.buttonCancel}
            </p>
          </CFButton>
        </>
      )}
      {firmaStyle === 'CEX' && (
        <>
          {/*           <CFCustomSeparator typeSignature={typeSignature}>
            {<CustomSeparator />}
          </CFCustomSeparator> */}
          <CFButtonChop >
            {/* <p
            onClick={() => window.location.reload()}
            style={{
              width: '250px',
              fontSize: '13px',
              color: '#7cb6c0',
              cursor: 'pointer',
            }}
          >
            ¿No carga la página? Pulsa aquí
          </p> */}
            <p
              onClick={() => emitRecancel(true)}
              style={{
                width: '100px',
                fontSize: '13px',
                color: '#7cb6c0',
                cursor: 'pointer',
              }}
            >
              {/*REVISAR TEXTO*/}
              {"Salir"}
            </p>
          </CFButtonChop>
        </>
      )}
    </CustomFooterStyle>
  );
};

export default CustomFooter;
